// src/admin/lib/storage.ts — fetch a 60s signed URL for a KYC/doc path and audit the view.

import { supabase } from './supabase';
import { recordAudit } from './audit';

export async function getSignedDocUrl(params: {
  bucket: 'kyc' | 'doc';
  path: string;
  target_type: 'kyc' | 'loan' | 'borrower';
  target_id: string;
  ttlSeconds?: number;
}): Promise<{ url: string; expiresAt: Date } | { error: string }> {
  const ttl = params.ttlSeconds ?? 60;
  const { data, error } = await supabase.storage.from(params.bucket).createSignedUrl(params.path, ttl);
  if (error || !data) return { error: error?.message ?? 'Failed to sign URL' };

  await recordAudit({
    action: 'kyc.view_media',
    target_type: params.target_type,
    target_id: params.target_id,
    payload: { bucket: params.bucket, path: params.path, ttl },
  });

  return { url: data.signedUrl, expiresAt: new Date(Date.now() + ttl * 1000) };
}
